// src/app/core/services/splash-screen.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
/**
 * Service to manage the lifecycle and removal of the application splash screen.
 */
export class SplashScreenService {
  /**
   * Hides and removes the splash screen container from the DOM.
   */
  public hide(): void {
    const splashScreen = document.getElementById('splashScreen');
    if (splashScreen) {
      splashScreen.classList.add('hidden-screen');
      // Set a small delay to allow the animation to finish before removing from DOM
  /**
   * Set timeout.
   *
   * @param ( - The ( parameter
   * @returns The Observable result
   */
      setTimeout(() => {
        splashScreen.remove();
      }, 500); // 500ms delay to match the animation duration
    }
  }
}
